import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { useExportCodeUse, useListCodeOfCustomer } from "hooks";
import React, { useEffect, useState } from "react";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap";
import useTable from "./useTable";

const initParams = {
  page: 1,
  sizePerPage: 10,
  columnFilter: {
    "filter[record_status]": "O",
    "filter[customer_id]": undefined,
  },
  run: false,
  expand: "",
};

const statusListAllOptions = [
  {
    value: "All",
    label: "Tất cả",
  },
  {
    value: "A",
    label: "Sử dụng",
  },
  {
    value: "M",
    label: "Chưa sử dụng",
  },
];

const CodeUseModal = ({ customer, isOpenCodeUse, toggleCodeUse }) => {
  const [params, setParams] = useState(initParams);
  const { columnTable, onTableChange, onSearchAllHandle } = useTable({
    params,
    setParams,
  });

  const [statusFilter, setStatusFilter] = useState(false);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
  const handleStatusFilter = status => {
    const columnFilter = { ...params.columnFilter };

    if (status.value !== "All") {
      setSelectedStatusFilter(status?.label);
      columnFilter["filter[auth_status]"] = status.value;
    } else {
      setSelectedStatusFilter(status?.label);
      delete columnFilter["filter[auth_status]"];
    }

    setParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const {
    data: codeOfCustomer,
    refetch: fetchCodeOfCustomer,
    isLoading,
  } = useListCodeOfCustomer({ params });

  useEffect(() => {
    if (customer && isOpenCodeUse) {
      setParams(prev => ({
        ...prev,
        columnFilter: {
          ...prev.columnFilter,
          "filter[customer_id]": customer?.id,
          "filter[auth_status]": "M",
        },
        run: true,
      }));
      setSelectedStatusFilter(statusListAllOptions[2]?.label);
    }
  }, [customer, isOpenCodeUse]);

  useEffect(() => {
    if (params.run) {
      fetchCodeOfCustomer();
    }
  }, [params]);

  const handleToggelModal = () => {
    setParams(initParams);
    toggleCodeUse();
  };

  const onExportSuccess = response => {
    if (response?.data) {
      const outputFilename = `CodeOfCustomer_${
        customer?.code
      }-${Date.now()}.xlsx`;
      const url = URL.createObjectURL(new Blob([response?.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  const { isLoading: isExportingFile, refetch: refetchExporCodeUse } =
    useExportCodeUse(
      {
        params: params,
      },
      onExportSuccess
    );

  const handleExportFile = () => {
    refetchExporCodeUse();
  };

  return (
    <Modal
      size="lg"
      role="dialog"
      autoFocus={true}
      centered={true}
      isOpen={isOpenCodeUse}
      toggle={handleToggelModal}
    >
      <ModalHeader toggle={handleToggelModal}>
        Danh sách mã của khách hàng {customer?.code} (
        {codeOfCustomer?.totalCount})
      </ModalHeader>
      <ModalBody>
        <RemoteDataTable
          keyField="id"
          data={codeOfCustomer?.items || []}
          columns={columnTable}
          page={params.page}
          sizePerPage={params.sizePerPage}
          totalSize={codeOfCustomer?.totalCount || 0}
          onTableChange={onTableChange}
          onSearchAllHandle={keywords =>
            setParams(prev => ({
              ...prev,
              keywords: keywords || undefined,
            }))
          }
          loading={isLoading}
        >
          <div
            className="d-flex"
            style={{
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                width: "fit-content",
              }}
            >
              <Dropdown
                isOpen={statusFilter}
                toggle={() => setStatusFilter(!statusFilter)}
              >
                <DropdownToggle
                  className="btn primary-btn w-100 text-overflow"
                  caret
                >
                  Trạng thái
                  {selectedStatusFilter && (
                    <span>:&nbsp;{selectedStatusFilter}</span>
                  )}
                  <i className="mdi mdi-chevron-down" />
                </DropdownToggle>
                <DropdownMenu className="w-100">
                  {statusListAllOptions?.length > 0 &&
                    statusListAllOptions.map((status, index) => (
                      <DropdownItem
                        key={`status-${index}`}
                        onClick={() => handleStatusFilter(status)}
                      >
                        {status.label}
                      </DropdownItem>
                    ))}
                </DropdownMenu>
              </Dropdown>
            </div>
            <Button
              className="mb-2"
              type="button"
              color="success"
              disabled={isExportingFile}
              onClick={handleExportFile}
            >
              Xuất file excel
            </Button>
          </div>
        </RemoteDataTable>
      </ModalBody>
    </Modal>
  );
};

export default CodeUseModal;
